module.exports = __webpack_public_path__ + "media/images/sample/product-4-e27615f8f0b856ae597922ffc13c4268.png";